import { Spinner as SpinnerComponent } from '@barfacil/barfacil-ui'

const Spinner: React.FC = () => (
  <div className="grid size-full place-content-center">
    <SpinnerComponent className="size-9" />
  </div>
)

export { Spinner }
